<template>
  <div class="header hidden-sm-and-down">
    <section class="myMain">
      <ul>
        <li>
          <i class="el-icon-phone"></i><span>业务咨询热线：010-8716 1759</span>
        </li>
        <li class="login">
          <span @click="showLogin()" v-if="!userNick"><i class="el-icon-user-solid"></i>登录</span>
          <el-dropdown v-else>
            <span><i class="el-icon-user-solid"></i>{{ userNick }}</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><span @click="loginOut">退出</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <span><i class="el-icon-s-operation"></i>网站导航</span> -->
        </li>
      </ul>
    </section>
    <login-dialog :isShow.sync="loginDialogVisible" @upUser="upUser" />
  </div>
</template>

<script>
import loginDialog from './loginDialog'
export default {
  data() {
    return {
      loginDialogVisible: false,
      userNick: localStorage.getItem('userNick'),
    };
  },
  components: {
    loginDialog,
  },
  methods: {
    showLogin(){
      console.log('header show login');
      this.loginDialogVisible = true;
    },
    upUser(val){
      this.userNick = val;
    },
    loginOut(){
      localStorage.clear();
      this.userNick = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: 40px;
  line-height: 40px;
  background-color: #f5f5f5;
  ul {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    li {
      color: #999999;
      font-size: 14px;
      i {
        margin-right: 5px;
      }
    }
    li.login {
      // span
      cursor: pointer;
      span:last-child {
        margin-left: 10px;
        padding-left: 10px;
        box-sizing: border-box;
        border-left: 2px solid #d5d4d4;
      }
    }
  }
}
</style>